<script>
import { formatDate } from "@/utils";

export default {
  name: "DateTimeBlinking",
  functional: true,
  props: {
    column: String,
    rowValue: String,
    row: Object
  },
  render: function (createElement, context) {
    let element;
    let { column, rowValue /*, row */ } = context.props;
    let actualDate = new Date();
    let rowDueDate = new Date(rowValue);

    //console.log("context: " , context )

    switch (column) {
      case "DueD": {
        if (rowDueDate < actualDate) {
          element = createElement(
            "p",
            {
              attrs: {
                class: "redBlinking"
              }
            },
            formatDate(rowValue, "DD/MM/YYYY")
          );
        } else {
          element = createElement(
            "p",
            {
              attrs: {
                //class: "redBlinking"
              }
            },
            formatDate(rowValue, "DD/MM/YYYY")
          );
        }
        break;
      }
      default: {
        element = createElement(
          "p",
          {
            attrs: {
              //class: "redBlinking"
            }
          },
          formatDate(rowValue, "DD/MM/YYYY")
        );
      }
    }
    return element;
  }
};
</script>

<style scoped>
.redBlinking {
  color: red;
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
